import { CSSProperties } from 'react';
import { colors } from 'src/style/themes/defaultTheme';
import styled, { css } from 'styled-components';

export const Container = styled.div``;
// Holds the step number badge beside the text
export const Title = styled.div`
    display: flex;
    align-items: center;
`;
export const Hint = styled.div`
    font-size: 12px;
    color: #616161;
    margin: 2px 0 6px;
`;

// The date range under the days title: it is what fills the days below it (owner, 2026-11-01)
export const RangeFrame = styled.div`
    margin: 6px 0 4px;
    padding: 10px 10px 4px;
    border: 1px solid #cfe3f7;
    border-radius: 10px;
    background: #f7fbff;
`;

export const DaysContainer = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
`;
export const DayContainer = styled.div<{
    disable: boolean;
    isFoucs: boolean;
    isCurrDay: boolean;
    canBeEnabled: boolean;
    isOrderedAlready: boolean;
    orderedShiftColor: string;
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    border: 1px solid #b4bec94d;
    width: 13%;
    height: 48px;
    border-radius: 4px;
    margin: 5px 0;
    font-family: Rubik;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0em;
    cursor: pointer;
    ${(props) =>
        props.disable &&
        props.canBeEnabled &&
        css`
            border: 1px solid ${colors.muiRed};
        `}
    ${({ disable }) =>
        disable &&
        css`
            opacity: 0.4;
            cursor: default;
            * {
                pointer: cursor;
            }
        `}
   ${({ isFoucs }) =>
        isFoucs &&
        css`
            border: 2px solid #40a8e2;
        `}

   ${(props) =>
        props.isOrderedAlready &&
        // !props.isFoucs &&
        props.orderedShiftColor &&
        `background-color: ${props.orderedShiftColor}`}
`;

export const WeekContainer = styled.div<{ style?: CSSProperties; isWeekOnTable?: boolean }>`
    ${(props) => {
        if (props.isWeekOnTable) {
            return css`
                border: 2px dashed ${colors.blue};
                padding: 0 5px;
                border-radius: 4px;
            `;
        }
    }}
`;
